import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-pb-4 tw-w-60"
}
const _hoisted_2 = { class: "d-flex tw-gap-1 tw-items-center" }
const _hoisted_3 = { class: "tw-text-gray-600 tw-text-xs tw-truncate" }
const _hoisted_4 = { class: "tw-text-gray-700 tw-truncate" }

import { computed, useSlots } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedLabeledText',
  props: {
  label: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;
const slots = useSlots();
const show = computed(() => Boolean(props.text || slots["text"]) && (props.label || slots["label"]));

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label", {}, () => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.label), 1)
          ]),
          _renderSlot(_ctx.$slots, "label-append")
        ]),
        _renderSlot(_ctx.$slots, "text", {}, () => [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.text), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})